import { createSelector } from 'reselect';

import type { ServiceConditionState } from './reducer';

import type { RootState } from 'typesafe-actions';

export const getErrors = (state: RootState) => state.serviceConditions.errors;

export const getServiceConditionsState = (state: RootState) => state.serviceConditions;

export const getServiceConditions = createSelector(
  getServiceConditionsState,
  (state: ServiceConditionState) => state.conditions,
);

export const getIsFetching = createSelector(
  getServiceConditionsState,
  (state: ServiceConditionState) => state.isFetching,
);
